// Meta Pixel utility for Facebook tracking
const PIXEL_ID = '1277274024081932'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    // Meta Pixel base code (hardened: doesn't rely on an existing <script> tag being present)
    ;(function (f: any, b: any, e: any, v: any) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e)
      t.async = !0
      t.src = v
      // Append to head or body — safer than relying on an existing <script> tag
      const target = b.head || b.body || b.documentElement
      if (target) {
        target.appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    if (window.fbq) {
      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    }

    // Noscript fallback pixel
    if (document.body) {
      const noscript = document.createElement('noscript')
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
      noscript.appendChild(img)
      document.body.appendChild(noscript)
    }
  } catch (err) {
    // Fail silently — never let analytics break the page
    console.warn('Meta Pixel init failed:', err)
  }
}

export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
}) {
  try {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'AddToCart', {
      value: params?.value ?? 47,
      currency: params?.currency ?? 'USD',
      content_name: params?.content_name ?? 'The AI Freelance Goldmine',
    })
  } catch (err) {
    console.warn('Meta Pixel AddToCart failed:', err)
  }
}
